export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-10.jpg'),
        title: 'CUSTOMER SERVICE',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: 'PROVIDING EXCELLENT CUSTOMER SERVICE, CUSTOMER EXPERIENCE DETERMINES OUR VALUE',
      description: `<p style="font-size:1.5rem">In the fierce market competition, customer service has become one of the important keys in the market. For enterprises,
the goal and the center of work are satisfying customers, and to meet customer needs. Today,
modern marketing concepts focus on customer needs and customer-oriented.
Enterprises get profit through customer satisfaction. Therefore, no matter before,
during or after sales, any company needs a professional customer service
team to make sure customer satisfaction.</p>`
    },
    {
      title: 'MAESINFO HAS PROFESSIONAL CUSTOMER SERVICE GROUP, THEY HAVE',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-10.jpg')+`)"></span>
      <span class="list">
      <i></i>Strong psychological quality in dealing with emergency situation<br/>
      <i></i>Good language expression ability, expert industry knowledge.<br/>
      <i></i>Has adhering to the ‘customer first service philosophy, dedicated customer service.
      </span>`
    }
  ]
}
